import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme, selectedValue) => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '1040px',
      margin: 'auto',
      marginBottom: '170px',
    },
  },
  shippingMethods: {
    width: '100%',
    maxWidth: '680px',
    maxHeight: '60vh',
    overflowY: 'scroll',
    [theme.breakpoints.up('sm')]: {
      marginTop: '-20px',
      maxHeight: '80vh',
      overflowY: 'scroll',
    },
  },
  titleContainer: {
    width: '100%',
    maxWidth: '680px',
    display: 'flex', 
    marginBottom: '10px', 
    justifyContent: 'space-between'
  },
  subtitle: {
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: theme.palette.primary.almostBlack,
    marginBottom: '9px',
  },
  subtitleInfo: {
    fontWeight: '300',
    fontSize: '12px',
    lineHeight: '15px',
    color: theme.palette.primary.almostBlack,
    marginBottom: '5px',
  },
  options: {
    fontWeight: '300',
    fontSize: '12px',
    color: theme.palette.primary.almostBlack,
  },
  card: {
    padding: '20px',
    margin: '15px',
    boxShadow: '0px 2px 14px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    border: '2px solid transparent',
    '&:active, &:hover': {
      borderColor: theme.palette.primary.typographyGreen,
    },

    [theme.breakpoints.up('sm')]: {
      margin: '20px',
      marginLeft: 0,
    },
  },
  cardInsideContainer: {
    alignItems: 'center',
    verticalAlign: 'center',
  },
  title: {
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: theme.palette.primary.almostBlack,
  },
  grid: {
    margin: '20px',
  },
  textInput: {
    borderRadius: '8px',
  },
  addressTitleActive: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '15px',
    color: theme.palette.primary.almostBlack,
  },
  addressDescriptionActive: {
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '15px',
    color: theme.palette.primary.almostBlack,
  },
  edit: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '15px',
    color: theme.palette.primary.moreBlue,
  },
}))
